

import React from 'react';
import { TruckDriverInsert } from '@/types';
import { AddEntityButton } from '@/shared/components/AddEntityButton';
import { FormField } from '@/shared/components/GenericFormDialog';

/**
 * トラック運転手情報の追加ボタンのprops
 */
interface AddTruckDriverButtonProps {
    onAdd: (data: TruckDriverInsert) => Promise<boolean>;
    className?: string;
    disabled?: boolean;
}

/**
 * トラック運転手情報の追加ボタン (Generic版)
 * 汎用AddEntityButtonを使用した実装
 */
export default function AddTruckDriverButton({
    onAdd,
    className,
    disabled = false
}: AddTruckDriverButtonProps) {

    // フォームフィールドの定義
    const fields: FormField[] = [
        {
            key: 'name',
            label: '運転手名',
            type: 'text',
            required: true,
            placeholder: '運転手名を入力してください',
        },
        {
            key: 'daily_rate',
            label: '日当（円）',
            type: 'number',
            required: false,
            placeholder: '日当を入力してください',
            min: 0,
        },
    ];

    /**
     * フォーム送信処理
     * @param data フォームデータ
     */
    const handleSubmit = async (data: Partial<Record<string, unknown>>) => {
        await onAdd(data as unknown as TruckDriverInsert);
    };

    return (
        <AddEntityButton
            entityName="運転手"
            fields={fields}
            onSubmit={handleSubmit}
            isLoading={disabled}
            buttonText="新規追加"
            className={className}
        />
    );
} 